import React from 'react'
import { Create, required, SimpleForm, TextInput, useNotify, useRedirect, useTranslate } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'

export const BannerTypeCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.banner-type') }
    })
    redirect('/banner-type')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.banner-type') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_bannerType')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput source='short_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <Grid xs={4} />
            <EditInputsWrap label={translate('ra.field.size_width')} md={3}>
              <NumberInput source='size_width' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.size_height')} md={3}>
              <NumberInput source='size_height' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.mobile_size_width')} md={3}>
              <NumberInput source='mobile_size_width' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.mobile_size_height')} md={3}>
              <NumberInput source='mobile_size_height' label={false} fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}